module.exports = __webpack_public_path__ + "static/img/beijing.5b7d6b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/beijing.jpg
// module id = +J8O
// module chunks = 0